var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarningIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 6,
    height: 30,
    viewBox: "0 0 6 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.00761 21.2011C2.61187 21.2011 2.2689 21.0615 1.97869 20.7821C1.71487 20.5028 1.55657 20.0978 1.50381 19.567L0.0395739 3.26816L0 2.84916C0 1.98324 0.277017 1.29888 0.83105 0.796089C1.41147 0.265363 2.13699 0 3.00761 0C3.931 0 4.6829 0.307263 5.26332 0.921788C5.84373 1.50838 6.08118 2.30447 5.97565 3.31006L4.51142 19.567C4.45865 20.0978 4.28716 20.5028 3.99696 20.7821C3.73313 21.0615 3.40335 21.2011 3.00761 21.2011ZM3.00761 30C2.16337 30 1.46423 29.7067 0.910198 29.1201C0.356164 28.5056 0.0791477 27.7514 0.0791477 26.8575C0.0791477 25.9637 0.356164 25.2235 0.910198 24.6369C1.46423 24.0223 2.16337 23.7151 3.00761 23.7151C3.85185 23.7151 4.55099 24.0223 5.10502 24.6369C5.65906 25.2235 5.93607 25.9637 5.93607 26.8575C5.93607 27.7514 5.65906 28.5056 5.10502 29.1201C4.55099 29.7067 3.85185 30 3.00761 30Z",
    fill: "#E5D34A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningIcon);
export default __webpack_public_path__ + "static/media/warning-icon.4353ec8829a15160d9b4c36bc445e282.svg";
export { ForwardRef as ReactComponent };